<template>
    <card-seplag titulo='Consultar E-mail'>
        <div class="p-col-12">
            <div class="p-grid p-fluid">
                <Rotulo nome="Selecione tipo assunto:" cols="12 6">
                    <Dropdown v-model="dropdown.tipoAssuntoSelecionado" :options="dropdown.tipoAssuntoList"
                        option-label="nomeAssunto" placeholder="Selecione uma opção..." :filter="true"
                        @change="buscarAssuntoPorTipoAssuntoRequest()" />
                </Rotulo>
                <Rotulo nome="Assunto" cols="12 6">
                    <Dropdown v-model="dropdown.assuntoSelecionado" :options="dropdown.assuntoList"
                        option-label="nomeAssunto" placeholder="Selecione uma opção..." :filter="true" />
                </Rotulo>
                <Rotulo nome="Órgão" cols="12 6">
                    <Dropdown v-model="dropdown.orgaoSelecionado" :options="dropdown.orgaoList" option-label="descricao"
                        placeholder="Selecione uma opção..." :filter="true" />
                </Rotulo>
            </div>
        </div>

        <div class="p-col-12">
            <div class="p-grid p-fluid center">
                <Rotulo cols="12 4">
                    <Button label="Limpar" class="botao" @click="limpar()" />
                </Rotulo>
                <Rotulo cols="12 4">
                    <Button label="Consultar" class="botao"
                        @click="buscarAssuntoPorTipoAssuntoEOuAssuntoEOuOrgaoRequest()" />
                </Rotulo>
            </div>
        </div>

        <div class="p-col-12">
            <hr>
        </div>
        <div class="p-col-12">
            <div class="p-grid p-fluid">
                <Rotulo cols="12 4">
                    <Button label="Adicionar" class="botao" @click="paginaCadastrarEditar(false)" />
                </Rotulo>
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-grid p-fluid center">
                <table-seplag :dados.sync="this.tabela.parametrosEmail" :campos="this.tabela.camposTabela"
                    :hasEventoAcao="true" :rows="10" :paginacao="true" :totalRegistro.sync="this.tabela.totalRegistro">
                    <Column header="Ativar / Inativar" headerStyle="width: 5.vw; " bodyStyle=" ">
                        <template #body="slotProps">
                            <div class="p-col-12 p-md-12 p-lg-12 ">
                                <InputSwitch v-model="slotProps.data.statParamAssuntoEmail"
                                    @change="atvarOuInativar(slotProps.data)" />
                            </div>
                        </template>
                    </Column>
                    <Column header="Editar" headerStyle="width: 2.vw; " bodyStyle=" ">
                        <template #body="slotProps">
                            <div class="p-col-12 p-md-12 p-lg-12 ">
                                <Button class="p-button-warning" icon="pi pi-user-edit"
                                    @click="paginaCadastrarEditar(slotProps.data)" />
                            </div>
                        </template>
                    </Column>
                    <Column header="Excluir" headerStyle="width: 2.vw; " bodyStyle=" ">
                        <template #body="slotProps">
                            <div class="p-col-12 p-md-12 p-lg-12 ">
                                <Button class="p-button-danger" icon="pi pi-times"
                                    @click="abrirModalExcluir(slotProps.data)" />
                            </div>
                        </template>
                    </Column>
                </table-seplag>
            </div>
        </div>
        <Dialog :header="modal.titulo" v-if="modal.exibirExcluir" :visible.sync="modal.exibirExcluir" :modal="true"
            :contentStyle="'min-width:30rem;min-height: 10rem;'">
            <div class="center">
                <p>Deseja realmente excluir o<strong> Parametro de Email?</strong></p>
            </div>
            <div class="p-col-12 ">
                <div class="p-grid p-fluid center">
                    <Rotulo cols="12 4">
                        <Button label="Não" class="botao " @click="fecharModal()" />
                    </Rotulo>
                    <Rotulo cols="12 4">
                        <Button label="Sim, excluir!" class="botao p-button-danger"
                            @click="excluirParametroEmailRequest()" />
                    </Rotulo>
                </div>
            </div>
        </Dialog>
    </card-seplag>
</template>

<script>
import { baseApiUrl } from "@/config/global";
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";


export default {
    components: { TableSeplag, Rotulo, CardSeplag },

    data: function () {
        return {
            url: {
                buscarTipoAssunto: "/assuntos/buscarTipoAssunto",
                buscarAssunto: "/assuntos/buscarAssunto",
                buscarAssuntoPorTipoAssunto: "/assuntos/buscarAssuntoPorTipoAssunto",
                buscarOrgaos: "/orgaos/naoextintos",
                buscarAssuntoPorTipoAssuntoEOuAssuntoEOuOrgao: "/paramassuntoemail/buscarportipoassuntoeouassuntoeouorgao",
                excluir: "/paramassuntoemail",
                salvarURL: "/paramassuntoemail"
            },
            dropdown: {
                tipoAssuntoSelecionado: null,
                tipoAssuntoList: [],
                assuntoSelecionado: null,
                assuntoList: [],
                orgaoSelecionado: null,
                orgaoList: [],

            },
            tabela: {
                parametrosEmail: [],
                totalRegistro: 0,
                camposTabela: [
                    { nome: 'assuntoPai.nomeAssunto', titulo: 'Tipo de Assunto', tamanho: '12.vw', alinhamento: "left" },
                    { nome: 'assunto.nomeAssunto', titulo: 'Assunto', tamanho: '12.vw', alinhamento: "left" },
                    { nome: 'orgao.descOrgao', titulo: 'Orgão', tamanho: '13.vw', alinhamento: "left" },
                    { nome: 'descEmail', titulo: 'E-mail', tamanho: '12.vw', alinhamento: "left" },
                ]
            },
            modal: {
                titulo: null,
                especie: null,
                exibir: false,
                exibirExcluir: false,
                item: null
            },
        }
    },
    methods: {
        async carregarDados() {
            this.buscarTipoAssuntoRequest(),
                this.buscarAssuntoRequest(),
                this.buscarOrgaoRequest()
        },
        removerElementoDaLista(idenParamAssuntoEmail) {
            let list = []
            for (let obj of this.tabela.parametrosEmail) {
                if (obj.idenParamAssuntoEmail !== idenParamAssuntoEmail) {
                    list.push(obj)
                }
            }
            this.tabela.parametrosEmail = list
        },
        abrirModalExcluir(data) {
            this.modal.item = data
            this.modal.exibirExcluir = true
            this.modal.titulo = `Excluir Parametro: ${data.descEmail}`
        },
        abrirModal(obj, titulo, especie) {
            this.buscarAssuntoRequest()
            this.modal.especie = especie
            this.modal.exibir = true
            this.modal.item = obj
            if (obj.descEmail == null) {
                this.modal.titulo = titulo
            } else {
                this.modal.titulo = titulo + ": " + obj.descEmail
            }
        },
        fecharModal() {
            this.modal.exibir = false
            this.modal.exibirExcluir = false
            this.modal.item = null
            this.modal.titulo = null
            this.modal.especie = null
        },
        buscarTipoAssuntoRequest() {
            this.$http.get(`${baseApiUrl}${this.url.buscarTipoAssunto}`).then(res => {
                //Ordenação
                this.dropdown.tipoAssuntoList = res.data.sort((a, b) => {
                    if (a.nomeAssunto < b.nomeAssunto) {
                        return -1; 
                    }
                    if (a.nomeAssunto > b.nomeAssunto) {
                        return 1;  
                    }
                    return 0;
                });
            })
        },
        buscarAssuntoRequest() {
            this.$http.get(`${baseApiUrl}${this.url.buscarAssunto}`).then(res => {
                //Ordenação
                this.dropdown.assuntoList = res.data.sort((a, b) => {
                    if (a.nomeAssunto < b.nomeAssunto) {
                        return -1; 
                    }
                    if (a.nomeAssunto > b.nomeAssunto) {
                        return 1;  
                    }
                    return 0;
                });
                console.log(this.dropdown.assuntoList);
            })
        },
        buscarAssuntoPorTipoAssuntoRequest() {
            this.$http.get(`${baseApiUrl}${this.url.buscarAssuntoPorTipoAssunto}` + "/" + `${this.dropdown.tipoAssuntoSelecionado.idenAssunto}`).then(res => {
                //Ordenação
                this.dropdown.assuntoList = res.data.sort((a, b) => {
                    if (a.nomeAssunto < b.nomeAssunto) {
                        return -1; 
                    }
                    if (a.nomeAssunto > b.nomeAssunto) {
                        return 1;  
                    }
                    return 0;
                });
            }).catch(() => {
                this.dropdown.assuntoList = []
            })
        },
        buscarOrgaoRequest() {
            this.$http.get(`${baseApiUrl}${this.url.buscarOrgaos}`).then(res => {
                this.dropdown.orgaoList = res.data
            })
        },
        buscarAssuntoPorTipoAssuntoEOuAssuntoEOuOrgaoRequest() {
            let parametrosEmailRequest = {
                "idenAssuntoPai": this.dropdown.tipoAssuntoSelecionado != null ? this.dropdown.tipoAssuntoSelecionado.idenAssunto : null,
                "idenAssunto": this.dropdown.assuntoSelecionado != null ? this.dropdown.assuntoSelecionado.idenAssunto : null,
                "idenOrgao": this.dropdown.orgaoSelecionado != null ? this.dropdown.orgaoSelecionado.idenOrgao : null
            }
            this.$http.get(`${baseApiUrl}${this.url.buscarAssuntoPorTipoAssuntoEOuAssuntoEOuOrgao}`, { params: parametrosEmailRequest }).then(res => {
                let novalista = res.data.content.map((e) => {
                    e.statParamAssuntoEmail ? e.statParamAssuntoEmail = true : e.statParamAssuntoEmail = false;
                    return e
                })
                this.tabela.parametrosEmail = novalista
                this.buscarAssuntoRequest()
                this.limpar()
            })
        },
        atvarOuInativar(obj) {
            let ativarOuInativarParametro = {
                "orgao": {
                    "idenOrgao": obj.orgao.idenOrgao
                },
                "assunto": {
                    "idenAssunto": obj.assunto.idenAssunto
                },
                "perfilAcesso": {
                    "id": obj.perfilAcesso.id
                },
                "statParamAssuntoEmail": obj.statParamAssuntoEmail ? 1 : 0,
                "descEmail": obj.descEmail
            }
            this.$http.put(`${baseApiUrl}${this.url.salvarURL}/${obj.idenParamAssuntoEmail}`, JSON.stringify(ativarOuInativarParametro)).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Ação efetuada', detail: obj.descEmail + " Registro editado com sucesso", life: 5000 });

            })
        },
        paginaCadastrarEditar(obj) {
            this.$store.commit("setParametroEmailEditar", obj)
            this.$router.push('/' + process.env.VUE_APP_BASE_URL + '/parametrizacoes/manterEmail')
        },
        excluirParametroEmailRequest() {
            this.$http.delete(`${baseApiUrl}${this.url.excluir}/${this.modal.item.idenParamAssuntoEmail}`).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Assunto deletado com sucesso', life: 1000 })
                this.removerElementoDaLista(this.modal.item.idenParamAssuntoEmail)
                this.fecharModal()
            })
        },
        limpar() {
            this.dropdown.tipoAssuntoSelecionado = null
            this.dropdown.assuntoSelecionado = null
            this.dropdown.orgaoSelecionado = null
        },
    },
    mounted() {
        this.carregarDados()
    }
}
</script>

<style scoped>
.center {
    justify-content: center;
    text-align: center;
    align-items: center;
}
</style>